'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLightbulb = function TiLightbulb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.8 9.2c-0.4 0-0.8 0.3-0.8 0.8s0.4 0.8 0.8 0.8c1.8 0 3.3 1.5 3.3 3.3 0 0.5 0.4 0.8 0.8 0.8s0.9-0.3 0.9-0.8c0-2.7-2.2-4.9-5-4.9z m0-7.5c-6.9 0-12.5 5.6-12.5 12.5 0 2.4 0.8 4.8 2.2 6.9 0 0.1 0 0.2 0.1 0.2 3 4.4 3.6 5.8 3.6 7v5c0 1 0.7 1.7 1.6 1.7h3.4c0 0.4 0.1 0.9 0.4 1.2 0.4 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.3-0.3 0.5-0.8 0.5-1.2h3.3c0.9 0 1.7-0.7 1.7-1.7v-5c0-1.3 0.5-2.6 3.6-7 1.4-2.1 2.2-4.6 2.2-7.1 0-6.9-5.6-12.5-12.5-12.5z m3.4 30h-6.7v-1.7h6.7v1.7z m4.1-12.3c-2.4 3.5-3.5 5.5-4 7.3h-1.8v-3.4c0-0.9-0.7-1.6-1.7-1.6s-1.6 0.7-1.6 1.6v3.4h-1.9c-0.4-1.7-1.5-3.7-3.8-7.1-0.1 0-0.1-0.1-0.2-0.2-1.1-1.5-1.6-3.4-1.6-5.2 0-5.1 4.1-9.2 9.1-9.2s9.2 4.1 9.2 9.2c0 1.8-0.6 3.7-1.7 5.2z' })
        )
    );
};

exports.default = TiLightbulb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/lightbulb.js
// module id = 3873
// module chunks = 0